// // Copyright (c) 2019-24 Stax·ai, Inc.
// // See LICENSE.md file in project root directory

import React, {  Component } from 'react';

// styles
import '../styles/style.css';

export default class Highlight extends Component {
        
    state = {
        matched: false, 
    }

    componentDidUpdate = (prev) => {
        if (prev.match !== this.props.match) 
            this.highlight(this.props.text, this.props.match);
        
        if (prev.match !== this.props.match && !this.props.match) 
            this.setState({chunks: []});
    }

    highlight = (s, m) => {

        let matched; 

        if (m && s?.toLowerCase().replace(/[^a-zA-Z0-9. ]/g, "").includes(m?.toLowerCase())) {
            matched = true
        } else {
            matched = false 
        }
    
        this.setState({matched});
    }

    render = () => {
        return <>{ this.state.matched ? <mark>{this.props.text}</mark>: this.props.text}</>;
    }
}
